<template>
  
	<div id="okanmap">
		<div id="vignette"></div>
		<div id="map"></div>
	</div>

</template>

<script>
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

export default {
	name: 'mapLayer',
	props: {
		okanMap : Object
	},
	data: function() {
		return {
	
			mapboxgl: mapboxgl

		}
	},
	mounted() {
		this.init();
	},
	created() {
		
	},
	destroyed() {

	},
	methods : {

		init() {

			
			this.okanMap.map = new this.mapboxgl.Map({
				container: 'map',
				style: this.okanMap.mapStyle,
				center : [ 4.06659, 48.29952 ],
				zoom: 8.71,
				minZoom: 4.6,
				pitch: 55,
				bearing: 0,
				renderWorldCopies: true,
				hash:true,
				attributionControl:true,
				preserveDrawingBuffer:true,
				navigationControl :true,
				antialias: true
			});

			this.okanMap.map.on('load', () => {

				this.okanMap.map.addControl(new this.mapboxgl.NavigationControl())

				this.okanMap.map.setPaintProperty('background', 'background-color', "hsl(47, 20%, 93%)");
				this.okanMap.map.setPaintProperty('landcover_wood', 'fill-opacity', 0.3);
				this.okanMap.map.setPaintProperty('park', 'fill-opacity', 0.3);
				this.okanMap.map.setPaintProperty('landcover_grass', 'fill-opacity', 0.3);
				this.okanMap.map.setPaintProperty('landuse_overlay_national_park', 'fill-opacity', 0.3);
				
				//this.okanMap.populate();
				//this.okanMap.testThreeDimCircle();
				$.get( 'data/maps/my_map.json', ( data ) => {

            
					this.okanMap.loadMapData(data, true);


					
					

					/*
					this.okanMap.sources.forEach((source) => {
						source.properties = this.okanMap.getSourceProperties(source)
					})*/
					
					

					//this.okanMap.sortLayers();

				}).fail((e, v =null) => {
					console.log( "error", e );
					console.log( "error details", v );
				});

				


				

			});

			
			
		}


	}
}
</script>


<style src="../assets/css/map.css"></style><style src="../assets/css/mapbox-gl.css"></style>